import { createReduxAsyncThunk } from 'shared/utils';
import { brandsAPI } from 'entities/brands';

import { BRANDS_STATE } from '../../constants';

import { FavouriteBrand } from '../../types';

export const addFavouriteBrands = createReduxAsyncThunk<
  { favouriteBrands: Pick<FavouriteBrand, 'billingId' | 'logo' | 'title'>[] },
  FavouriteBrand['billingId'][]
>(
  `${BRANDS_STATE}/addFavouriteBrands`,
  async (billingIds) => {
    const { data } = await brandsAPI.addFavouriteBrands(billingIds);
    return data;
  }
);
